import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';

// dashboard routing
// const DashboardDefault = Loadable(lazy(() => import('views/dashboard/Default')));
// const PdfViewer = Loadable(lazy(() => import('views/application/PdfViewer')));
// const CouponsList = Loadable(lazy(() => import('views/application/CouponList')));
// const Beacon = Loadable(lazy(() => import('views/application/Beacon')));
// const MediaManager = Loadable(lazy(() => import('views/application/MediaManager')));
// const NotificationList = Loadable(lazy(() => import('views/application/NotificationList')));
// const Shop = Loadable(lazy(() => import('views/application/Shop')));
// const EventSchedule = Loadable(lazy(() => import('views/application/EventSchedule')));

// pricing page routing
const Subscription = Loadable(lazy(() => import('views/application/Subscription')));

// const PagesPrice2 = Loadable(lazy(() => import('views/pages/pricing/Price2')));
const SubscriptionHistory = Loadable(lazy(() => import('views/application/SubscriptionHistory')));

const DeleteAccount = Loadable(lazy(() => import('views/application/DeleteAccount')));

const Favorite = Loadable(lazy(() => import('views/application/Favorite')));

const MethodOfPayment = Loadable(lazy(() => import('views/application/MethodOfPayment')));

const Account = Loadable(lazy(() => import('views/application/Account')));

const ProviderUser = Loadable(lazy(() => import('views/application/ProviderUser')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: (
    <AuthGuard>
      <MainLayout />
    </AuthGuard>
  ),
  children: [
    {
      path: '/mypage',
      element: <ProviderUser />
    },
    {
      path: '/subscription',
      element: <Subscription />
    },
    {
      path: '/subscriptionhistory',
      element: <SubscriptionHistory />
    },
    {
      path: '/deleteaccount',
      element: <DeleteAccount />
    },
    {
      path: '/favorite',
      element: <Favorite />
    },
    {
      path: '/methodofpayment',
      element: <MethodOfPayment />
    },
    {
      path: '/account',
      element: <Account />
    }
  ]
};

export default MainRoutes;
